/**
 * Copy text to clipboard.
 * https://stackoverflow.com/questions/39501289/in-reactjs-how-to-copy-text-to-clipboard
 */
export const copyToClipboard = (text: string) =>
  navigator.clipboard.writeText(text);
